import { useAuth } from './useAuth';
import { getPermissionLevel } from './hasPermission';
import type { PermissionLevel } from './types';

/**
 * Efektivní úroveň přístupu přihlášeného uživatele k uzlu katalogu
 * (`none` během načítání / bez přihlášení; config uživatel má vždy `edit`).
 */
export function usePermission(permission: string): PermissionLevel {
  const auth = useAuth();
  return getPermissionLevel(auth.status === 'authenticated' ? auth.user : null, permission);
}

export interface FieldPermissionState {
  /** Efektivní úroveň uzlu. */
  level: PermissionLevel;
  /** Uzel je viditelný (alespoň `read`) — jinak pole vůbec nerenderovat. */
  visible: boolean;
  /** Uzel je editovatelný (`edit`) — jinak pole zobrazit read-only/disabled. */
  editable: boolean;
}

/**
 * Field-level oprávnění pro políčko formuláře / sekci. Párový kontrakt k backendovému field
 * guardu (`[RequirePermission]` na property commandu): pole bez `editable` se nesmí odeslat
 * (viz `stripFieldsWithoutEdit`), backend by ho odmítl 403.
 */
export function useFieldPermission(permission: string): FieldPermissionState {
  const level = usePermission(permission);
  return { level, visible: level !== 'none', editable: level === 'edit' };
}
